import Column from '@components/Column';
import Header from '@components/Header';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import MessageIcon from '@icons/MessageIcon';
import PenIcon from '@icons/PenIcon';
import PhoneIcon from '@icons/PhoneIcon';
import { useFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import NativeUtil from '@utils/NativeUtil';
import { Fragment, useMemo } from 'react';

import CsImage from './components/CsImage';
import CsItem from './components/CsItem';

const CustomerServiceActivity: ActivityComponentType = () => {
  const { push } = useFlow();
  const project = useProject();
  const inquiryInfo = project?.inquiryInfo;
  const phoneContent = useMemo(() => {
    if (inquiryInfo) {
      const { phoneNote, phoneBusinessHours } = inquiryInfo;
      return [phoneNote, phoneBusinessHours].filter(Boolean).join('\n');
    }
    return '';
  }, [inquiryInfo]);
  const externalContent = useMemo(() => {
    if (inquiryInfo) {
      const { externalPhoneNumber, externalBusinessHours } = inquiryInfo;
      return [externalBusinessHours, externalPhoneNumber].filter(Boolean).join('\n');
    }
    return '';
  }, [inquiryInfo]);
  return (
        <AppScreen>
            <Header title='고객센터' noShadow/>
            <Container spacing={24} fullWidth align='center'>
                <Column spacing={8} fullWidth>
                    <Text size='xl' fontWeight='medium' color={colors.gray9}>
                        안녕하세요.<br/>
                        {project?.name} 고객센터입니다.
                    </Text>
                    <Text color={colors.gray7}>
                        문의하실 채널을 선택해주세요.
                    </Text>
                </Column>
                <CsImage/>
                {inquiryInfo && (
                    <Fragment>
                        <Column fullWidth spacing={8}>
                            {inquiryInfo.inAppInquiryEnabled && (
                                <CsItem icon={PenIcon}
                                        title='1:1 문의 게시판'
                                        content={inquiryInfo.inAppNote}
                                        onClick={() => push('InquiryActivity', { type: 'WRITE' })} />
                            )}
                            {inquiryInfo.phoneEnabled && (
                                <CsItem icon={PhoneIcon}
                                        title='고객센터 전화'
                                        content={phoneContent}
                                        onClick={() => NativeUtil.postMessage('openExternalLink', `tel:${inquiryInfo?.phoneNumber}`)} />
                            )}
                            {inquiryInfo.externalInquiryEnabled && (
                                <CsItem icon={MessageIcon}
                                        title='자체 문의센터'
                                        content={externalContent}
                                        onClick={() => NativeUtil.postMessage('openExternalLink', inquiryInfo.externalInquiryUrl)} />
                            )}
                        </Column>
                    </Fragment>
                )}
            </Container>
        </AppScreen>
  );
};

const Container = styled(Column)`
    padding: 16px;
`;

export default CustomerServiceActivity;
